//export const CalendarCategoryId = 5;

export const VendorConstant = {
    CalendarCategoryId: 5,
    CalendarCategoryHeader: 'Calendar',
    ContactAndCalendarSyncCategoryId: 20,
    ContactAndCalendarSyncHeader: 'Contact and Calendar'
}